import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/pacerSearch.js';
import PacerSearch from '../components/search/sections/pacerSearch/PacerSearch.jsx';

import '../less/BootstrapCustom.less';


class LayoutOfPacerSearch extends Component {
  render() {
    const { pacerSearchResults } = this.props;
    return (
      <div>
        <PacerSearch {...this.props} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    pacerSearchResults: state.get('pacerSearchResults')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LayoutOfPacerSearch)



/** WEBPACK FOOTER **
 ** ./src/containers/LayoutOfPacerSearch.js
 **/